export default "__VITE_ASSET__NpiZSYKf__"